module.exports = __webpack_public_path__ + "img/04.e2c42efd.jpg";